export const adminPageLoaders = {
  AdminLogin: () => import("../pages/admin/Login"),
  AdminDashboard: () => import("../pages/admin/Dashboard"),
  ApprovalInbox: () => import("../pages/admin/ApprovalInbox"),
  AdminControlCenter: () => import("../pages/admin/AdminControlCenter"),
  AdminEmployees: () => import("../pages/admin/Employees"),
  AdminAttendance: () => import("../pages/admin/AttendanceReport"),
  AdminEscalations: () => import("../pages/admin/Escalations"),
  AbsenceWithoutLeave: () => import("../pages/admin/AbsenceWithoutLeave"),
  HrCommand: () => import("../pages/admin/HrCommand"),
  GeneralLetters: () => import("../pages/admin/GeneralLetters"),
  SalesLiveTracking: () => import("../pages/admin/SalesLiveTracking"),
  AdminLunchAlerts: () => import("../pages/admin/LunchAlerts"),
  DepartmentEfficiency: () => import("../pages/admin/DepartmentEfficiency"),
  AdminEod: () => import("../pages/admin/EodReport"),
  AdminTasks: () => import("../pages/admin/Tasks"),

  AdminComplaints: () => import("../pages/admin/Complaints"),
  AdminOffboarding: () => import("../pages/admin/Offboarding"),
  AdminPolicies: () => import("../pages/admin/Policies"),
  WFH: () => import("../pages/admin/WFH"),
  AdminAnnouncements: () => import("../pages/admin/Announcements"),
  AdminLeave: () => import("../pages/admin/AdminLeave"),
  AdminGeofencing: () => import("../pages/admin/Geofencing"),
  AdminExpenses: () => import("../pages/admin/Expenses"),
  FinanceCommand: () => import("../pages/admin/FinanceCommand"),
  CompanySettings: () => import("../pages/admin/CompanySettings"),
  SelfieAccess: () => import("../pages/admin/SelfieAccessPage"),
};

let adminPreloadPromise = null;
const preloadedAdminRoutes = new Set();

const adminRouteLoaders = {
  "/admin/dashboard": adminPageLoaders.AdminDashboard,
  "/admin/payroll-locking-system": adminPageLoaders.AdminControlCenter,
  "/admin/approval-inbox": adminPageLoaders.ApprovalInbox,
  "/admin/employees": adminPageLoaders.AdminEmployees,
  "/admin/attendance": adminPageLoaders.AdminAttendance,
  "/admin/escalations": adminPageLoaders.AdminEscalations,
  "/admin/absence-without-leave": adminPageLoaders.AbsenceWithoutLeave,
  "/admin/hr": adminPageLoaders.HrCommand,
  "/admin/general-letters": adminPageLoaders.GeneralLetters,
  "/admin/sales-live-tracking": adminPageLoaders.SalesLiveTracking,
  "/admin/lunch-alerts": adminPageLoaders.AdminLunchAlerts,
  "/admin/department-efficiency": adminPageLoaders.DepartmentEfficiency,
  "/admin/eod": adminPageLoaders.AdminEod,
  "/admin/tasks": adminPageLoaders.AdminTasks,

  "/admin/complaints": adminPageLoaders.AdminComplaints,
  "/admin/offboarding": adminPageLoaders.AdminOffboarding,
  "/admin/policies": adminPageLoaders.AdminPolicies,
  "/admin/wfh": adminPageLoaders.WFH,
  "/admin/announcements": adminPageLoaders.AdminAnnouncements,
  "/admin/leave": adminPageLoaders.AdminLeave,
  "/admin/geofencing": adminPageLoaders.AdminGeofencing,
  "/admin/expenses": adminPageLoaders.AdminExpenses,
  "/admin/finance": adminPageLoaders.FinanceCommand,
  "/admin/settings": adminPageLoaders.CompanySettings,
  "/admin/selfie-access": adminPageLoaders.SelfieAccess,
};

const scheduleIdle = (callback) => {
  if (typeof window === "undefined") return undefined;
  if ("requestIdleCallback" in window) {
    const id = window.requestIdleCallback(callback, { timeout: 2000 });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(callback, 100);
  return () => window.clearTimeout(id);
};

export const preloadAdminPageForPath = (path) => {
  const load = adminRouteLoaders[path];
  if (!load || preloadedAdminRoutes.has(path)) return Promise.resolve();
  preloadedAdminRoutes.add(path);
  return load().catch(() => {
    preloadedAdminRoutes.delete(path);
  });
};

export const preloadAdminPages = () => {
  if (!adminPreloadPromise) {
    const routes = Object.keys(adminRouteLoaders);
    adminPreloadPromise = new Promise((resolve) => {
      let index = 0;
      const loadNext = () => {
        const route = routes[index];
        index += 1;
        if (!route) {
          resolve();
          return;
        }
        preloadAdminPageForPath(route).finally(() => scheduleIdle(loadNext));
      };
      scheduleIdle(loadNext);
    });
  }

  return adminPreloadPromise;
};
